<template>
  <div class="info">
    <div class="head">
      <div class="info_icon"><img v-lazy="require('@/assets/home/icon3.png')" alt="" /></div>
      <span>LATEST INFORMATION</span>
      <h3>最新资讯</h3>
      <div class="text_info">
        为您提供最新的保函政策和保函资讯
      </div>
    </div>
    <div class="details">
      <div class="tab" v-for="(item, index) in listData" :key="index">
        <div class="pictrue"><img v-lazy=item.img alt="" /></div>
        <div class="info_titel" style="position:relative">
          <div>
            <p>{{ item.title }}</p>
            <div class="type">
              <div>{{ item.time }}</div>
              <div class="tag">{{ item.classify }}</div>
            </div>
            <div class="info_text">
              {{ item.text }}
            </div>
          </div>
          <div>
            <el-button @click="toPages(item.toPage)" style="position:absolute;bottom:5px;">查看详情</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listData: [
        {
          img: require('@/assets/newPage/打击整治网络谣言倡议书.jpg'),
          title: '打击整治网络谣言倡议书',
          time: '2024.1.15',
          classify: '网站公告',
          text: '打击整治网络谣言倡议书',
          toPage: '/newInfo?id=8'
        },
        {
          img: require('@/assets/newPage/gonggaozixun/电子投标保函是什么意思1.jpg'),
          title: '电子投标保函是什么意思？怎么办理电子投标保函？',
          time: '2023.3.10',
          classify: '保函资讯',
          text: '先说电子投标保函到底是什么？大家可以理解为投标保函的电子版，但是这里要区分两个概念，一个是传统纸质保函的扫描电子版，一个是真正的电子投标保函，真正的电子保函是采用加密手段，通过互联网技术办理的电子化投标保函，相对于传统纸质保函扫描电子版，具有有据可查，追根溯源等一系列特点，对于招投标电子信用体系建设具有重要作用',
          toPage: '/newInfo?id=1'
        },
        {
          img: require('@/assets/newPage/gonggaozixun/石家庄投标保函办理1.jpg'),
          title: '石家庄投标保函办理需要提供什么材料？',
          time: '2023.3.9',
          classify: '保函资讯',
          text: '现在投标保函办理所需材料根据保函类型来区分，其中招标文件和营业执照是必须材料。投标保函根据类型分为电子投标保函、银行投标保函、投标保证保险三种，其中投标保证保险办理最为简单，只需提供招标文件、营业执照就可以，提供投标企业基本户打款信息即可出函。',
          toPage: '/newInfo?id=2'
        },
        {
          img: require('@/assets/newPage/gonggaozixun/投标保函有效期和投标有效期有什么不同1.jpg'),
          title: '投标保函的有效期与投标有效期有什么区别？',
          time: '2023.3.8',
          classify: '保函资讯',
          text: '二者一个是保函的有效期，一个是投标的有效期，二者不能混为一谈。为什么经常将这两个有效期在一起说，是因为投标保函的有效期是根据投标有效期来的。',
          toPage: '/newInfo?id=3'
        },
      ]
    };
  },
  created() { },
  mounted() { },
  methods: {
    toPages(pag) {
      this.$router.push(pag)
    }
  },
};
</script>

<style lang='less' scoped>
.info {
  padding: 70px 10%;
  background-color: #f7f7f7;
  font-size: 17px;

  .head {
    display: flex;
    flex-direction: column;
    align-items: center;

    .info_icon {
      width: 120px;
      height: 80px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    span {
      margin-top: 15px;
      font-size: 20px;
    }
  }

  h3 {
    text-align: center;
    margin-top: 15px;
    font-size: 24px;
  }

  .text_info {
    margin-top: 15px;
    font-size: 16px;
  }

  .details {
    width: 1200px;
    margin: 25px auto 0 auto;
    display: flex;
    justify-content: space-between;

    .tab {
      width: 372px;
      cursor: pointer;

      &:hover img {
        transform: scale(1.1);
      }

      .pictrue {
        overflow: hidden;
        // width: 372px;
        // height: 240px;

        img {
          width: 100%;
          height: 100%;
          transition: all .3s;
        }

      }

      .info_titel {
        padding: 20px;
        background-color: #ffffff;
        height: 205px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        p {
          font-weight: bold;
        }

        .type {
          display: flex;
          font-size: 14px;
          font-weight: bold;
          align-items: end;
          margin: 10px 0;

          .tag {
            margin-left: 20px;
          }
        }

        .info_text {
          font-size: 13px;
          color: #939ba2;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

.el-button {
  border: 1px solid #696969;
  font-weight: bold;
  padding: 10px 20px;
  margin-top: 15px;
  color: #000000;
}

.el-button:focus,
.el-button:hover {
  background-color: #fff;
  color: #ffb520;
  border: 1px solid #ffb520;
  font-weight: bold;
}
</style>